module.exports = __webpack_public_path__ + "static/img/1.b7c9ffde.png";